/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";


//i18n
import { withNamespaces } from "react-i18next";

// import Button from "../Button"

// icon

// util
import Icon from "../../Icon";
import { classnames } from "../../../utils/text";



const AdministrativeCertificateItem = ({ icon, disabled, label, id, selectAdministrativeCertificateIssue }) => {


  return <div className={classnames("issue-button-box", {
    disabled,
  })}>
    <a
      className={classnames("issue-button")}
      onClick={() => {
        if (disabled) return;
        selectAdministrativeCertificateIssue(id);
      }}
    >
      <span className="icon">
        <Icon src={icon} />
      </span>
      {label}
    </a>
  </div>;
};

const AdministrativeCertificateIssueList = ({ administrativeCertificateList, selectAdministrativeCertificateIssue }) => (
  <>
    <div className="task-issue-list-wrap">

      <div className="task-issue-list-box">
        <div className="task-issue-list">
          {administrativeCertificateList
            .filter(({ id }) => !!id)
            .map(({ label, id, icon, disabled }, idx) => (
              <AdministrativeCertificateItem
                id={id}
                icon={icon}
                label={label}
                disabled={disabled}
                key={idx}
                selectAdministrativeCertificateIssue={selectAdministrativeCertificateIssue}
              />
            ))}
        </div>
      </div>
    </div>
  </>
);

export default withNamespaces()(AdministrativeCertificateIssueList);
